// src/routes/filterRoutesForUser.js
// -----------------------------------------------------------------------------
// Filtre récursivement l'arbre de routes selon le rôle utilisateur.
// - Respecte la sémantique isRoleAllowed :
//     * allowedRoles absent  -> autoriser
//     * allowedRoles []      -> interdire tout le monde
// - Masque un parent si tous ses enfants sont interdits.
// -----------------------------------------------------------------------------

import { isRoleAllowed } from "context/roles";

export function filterRoutesForUser(routes, userRole) {
  const walk = (items) =>
    (items || [])
      .filter((r) => isRoleAllowed(userRole, r.allowedRoles))
      .map((r) => (r.collapse ? { ...r, collapse: walk(r.collapse) } : r))
      .filter((r) => !(r.collapse && r.collapse.length === 0)); // si parent sans enfants autorisés -> retire

  return walk(routes);
}
